module.exports = __webpack_public_path__ + "img/logo_color.18c99274.png";